/* Manikidz — urgence (compte à rebours réel, date de livraison) et vidéos « en action » */
(function () {
  'use strict';

  function pad(n) { return String(n).padStart(2, '0'); }

  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }

  var fmt;
  try { fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' }); } catch (e) { fmt = null; }
  function fr(d) { return fmt ? fmt.format(d).replace(/\.$/, '') : d.toLocaleDateString('fr-FR'); }

  function initUrgency(scope) {
    (scope || document).querySelectorAll('[data-mk-urg]').forEach(function (el) {
      if (el.__mk) return;
      el.__mk = true;

      var dates = el.querySelector('[data-mk-urg-dates]');
      if (dates) {
        var min = parseInt(el.getAttribute('data-min'), 10) || 5;
        var max = Math.max(min, parseInt(el.getAttribute('data-max'), 10) || 9);
        var now = new Date();
        dates.textContent = fr(addBusinessDays(now, min)) + ' et le ' + fr(addBusinessDays(now, max));
      }

      var timer = el.querySelector('[data-mk-urg-timer]');
      var deal = el.querySelector('[data-mk-urg-deal]');
      var endAttr = el.getAttribute('data-end');
      if (!timer || !endAttr) return;
      var end = new Date(endAttr.length === 16 ? endAttr + ':00' : endAttr);
      if (isNaN(end.getTime())) { if (deal) deal.hidden = true; return; }

      function tick() {
        var diff = Math.floor((end.getTime() - Date.now()) / 1000);
        if (diff <= 0) {
          if (deal) deal.hidden = true;
          if (!el.querySelector('.mk-urg__stock, .mk-urg__ship')) el.hidden = true;
          return false;
        }
        var d = Math.floor(diff / 86400);
        var h = Math.floor((diff % 86400) / 3600);
        var m = Math.floor((diff % 3600) / 60);
        var s = diff % 60;
        timer.textContent = (d > 0 ? d + ' j ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
        return true;
      }
      if (tick()) {
        var id = setInterval(function () { if (!tick()) clearInterval(id); }, 1000);
      }
    });
  }

  /* Vidéos « en action » : lecture seulement quand elles sont visibles */
  function initClips(scope) {
    var vids = (scope || document).querySelectorAll('[data-mk-clip] video');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { v.play && v.play().catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { if (!v.__mk) { v.__mk = true; io.observe(v); } });
  }

  function init(scope) { initUrgency(scope); initClips(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.MKUrgency = { init: init };
})();
